export class userProfileController {
    loadComplete = false;
    user: any;
    loading: boolean = true
    constructor(private $user, private $ocLazyLoad, private $state) {
        "ngInject"

    }
    $onInit() {
        this.$ocLazyLoad.load("user-profile").then(res => {
            this.loadComplete = true
            if(this.$state.current.name.indexOf('profile') == -1){
                this.$state.go('profile.orders')
            }
        })
        this.$user.getInfo().then(
            user => {
                if (user.data) {
                    this.user = user.data;
                }
                this.loading = false;
            }
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/user-profile/user-profile.controller.ts